export enum PlatformComponentKey {
  API = 'API',
  AUTHENTICATION = 'AUTHENTICATION',
  FILES = 'FILES',
  REALTIME = 'REALTIME',
  EMAIL = 'EMAIL',
  WEB = 'WEB',
  MOBILE = 'MOBILE',
}

export enum PlatformComponentState {
  OPERATIONAL = 'OPERATIONAL',
  DEGRADED = 'DEGRADED',
  OUTAGE = 'OUTAGE',
  MAINTENANCE = 'MAINTENANCE',
  UNKNOWN = 'UNKNOWN',
}

export enum PlatformStatusSeverity {
  INFO = 'INFO',
  MAINTENANCE = 'MAINTENANCE',
  INCIDENT = 'INCIDENT',
}

export interface PlatformStatusComponent {
  key: PlatformComponentKey;
  name: string;
  state: PlatformComponentState;
  description: string;
  publicMessage?: string | null;
}

export interface PlatformStatusMessage {
  title: string;
  body: string;
  severity: PlatformStatusSeverity;
  publishedAt: string;
}

export interface PlatformStatus {
  overall: PlatformComponentState;
  components: PlatformStatusComponent[];
  message?: PlatformStatusMessage | null;
  mobile: {
    minimumSupportedVersion?: string | null;
  };
  sampledAt: string;
  /** True when the backend's own sampler has stopped reporting. */
  stale: boolean;
}

export interface PlatformDependencyDetail {
  label: string;
  status: string;
  latencyMs: number;
  error?: string | null;
}

export interface PlatformClientMetric {
  client: string;
  total: number;
  errors: number;
  /** Null below the minimum volume floor — not enough traffic to judge. */
  errorRate?: number | null;
  windowMinutes: number;
}

export interface PlatformStatusOverride {
  componentKey: PlatformComponentKey;
  state: PlatformComponentState;
  publicMessage?: string | null;
  internalNote?: string | null;
  expiresAt?: string | null;
}

export interface PlatformStatusDetail extends PlatformStatus {
  dependencies: PlatformDependencyDetail[];
  metrics: PlatformClientMetric[];
  overrides: PlatformStatusOverride[];
}
